import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress benign ResizeObserver loop error (harmless; from browser/layout or libraries like Leaflet)
window.addEventListener('error', (e) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
    return true;
  }
});

// Capture install prompt globally for direct "Install" button flow.
window.__installPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__installPrompt = e;
  window.dispatchEvent(new CustomEvent('installPromptAvailable'));
});
window.addEventListener('appinstalled', () => {
  window.__installPrompt = null;
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const base = process.env.PUBLIC_URL || '';
    navigator.serviceWorker.register(`${base}/sw.js`)
      .then(() => {
        console.info('[PUSH] Service worker registered from index.js');
      })
      .catch((error) => {
        console.error('[PUSH] Service worker registration failed in index.js:', error);
      });
  });
  // Debug helper: run window.__unregisterServiceWorker() in console if stuck with 429/old SW
  window.__unregisterServiceWorker = () => {
    navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);







